module.exports = __webpack_public_path__ + "img/warmness_illustration.d589cae4.jpg";